import { Routes, Route } from 'react-router-dom';

import { DashboardLayout } from '@/layouts/DashboardLayout';
import { AuthLayout } from '@/layouts/AuthLayout';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { AdminRoute } from '@/components/common/AdminRoute';

import { LoginPage } from '@/pages/auth/LoginPage';
import { DashboardPage } from '@/pages/dashboard/DashboardPage';
import { UsersPage } from '@/pages/users/UsersPage';
import { VendorsPage } from '@/pages/vendors/VendorsPage';
import { VendorDetailPage } from '@/pages/vendors/VendorDetailPage';
import { PartnershipRequestsPage } from '@/pages/vendors/PartnershipRequestsPage';
import { VendorSalesPage } from '@/pages/vendors/VendorSalesPage';
import { CategoriesPage } from '@/pages/categories/CategoriesPage';
import { OnboardingPage } from '@/pages/onboarding/OnboardingPage';
import { ProfileSettingsPage } from '@/pages/settings/ProfileSettingsPage';
import { SettingsPage } from '@/pages/settings/SettingsPage';
import { SimpleFormPage } from '@/pages/SimpleFormPage';
import { ComprehensiveFormPage } from '@/pages/ComprehensiveFormPage';
import { PortalConfigPage } from '@/pages/config/PortalConfigPage';
import { ReferralConfigPage } from '@/pages/config/ReferralConfigPage';
import { ReferralReportPage } from '@/pages/referral/ReferralReportPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

export function App() {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/profile" element={<ProfileSettingsPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />

          {/* Settings Routes */}
          <Route path="/settings" element={<SettingsPage />} />

          {/* Form Examples */}
          <Route path="/forms" element={<SimpleFormPage />} />
          <Route path="/forms/comprehensive" element={<ComprehensiveFormPage />} />

          {/* Admin Routes */}
          <Route element={<AdminRoute />}>
            <Route path="/users" element={<UsersPage />} />
            <Route path="/referral-report" element={<ReferralReportPage />} />
            <Route path="/vendors" element={<VendorsPage />} />
            <Route path="/vendors/:merchantId" element={<VendorDetailPage />} />
            <Route path="/partnership-requests" element={<PartnershipRequestsPage />} />
            <Route path="/vendor-sales" element={<VendorSalesPage />} />
            <Route path="/categories" element={<CategoriesPage />} />
            <Route path="/portal-config" element={<PortalConfigPage />} />
            <Route path="/referral-config" element={<ReferralConfigPage />} />
          </Route>
        </Route>
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
